var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"j-end"},[_c('b-button',{staticClass:"m-t-10",attrs:{"variant":"primary"},on:{"click":_vm.add}},[_c('i',{staticClass:"icon-plus"}),_vm._v(" Agregar descripcion ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }